/** Matches backend LANGUAGE enum */
export const TV_CHANNEL_LANGUAGES = [
  "ENGLISH",
  "HINDI",
  "MARATHI",
  "GUJARATI",
  "TAMIL",
  "TELUGU",
];
